<template>
  <div class="marunage-chat">
    <div class="ui vertical top loader" :class="{'active': loading}"></div>
    <div class="chat-column">
      <div class="chatItemContainer">
        <div v-for="comment in comments" :key="comment.id">
          <div v-if="comment.is_own && comment.text" class="chatItem">
            <div class="chatItem__talk chatItem__talk--self">
              <div class="chatItem__talkMainContainer">
                <div class="chatItem__balloon chatItem__balloon--self">
                  <div class="chatItem__text linebreak" v-html="$options.filters.urlize(comment.text)"></div>
                </div>
                <div class="chatItem__metaContainer  chatItem__metaContainer--self">
                  <span class="chatItem__readStatus" v-show="comment.read">既読</span>
                  <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="comment.text" class="chatItem">
            <div class="chatItem__talk chatItem__talk--peer">
              <div class="chatItem__talkMainContainer chatItem__talkMainContainer--peer">
                <div class="chatItem__balloon chatItem__balloon--peer">
                  <div v-if="comment.text" class="chatItem__text linebreak" v-html="$options.filters.urlize(comment.text)"></div>
                </div>
                <div class="chatItem__metaContainer chatItem__metaContainer--peer">
                  <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="comment.json.type === 'SUGGESTION_EXPLANATION'" class="chatItem">
            <div class="chatItem__talk chatItem__talk--self">
              <div class="chatItem__talkMainContainer chatItem__talkMainContainer--self">
                <div class="chatItem__balloon chatItem__balloon--self">
                  <div class="chatItem__text">
                    会場が見つかりました！<br />
                    ご紹介した会場で<span class="chatItem__kininaruInlineBoxSuggestion">空き確認</span>を押すと、ご希望の条件で利用できるかお調べいたします！<br />
                    空きの有無は各会場の担当者からチャットにてご連絡しますので、直接詳細をご確認ください。<br />
                    ご予約は会場とのチャットでそのままご依頼いただけます。
                  </div>
                  <div class="chatItem__text--info">
                  予約日時や人数を変更されたい場合は、以下の「予約日時・人数の変更」から変更ください。<br />
                  別なエリア、または複数のエリアでお探しの際はチャットにてお申し付けください。
                  </div>
                </div>
                <div class="chatItem__metaContainer  chatItem__metaContainer--self">
                  <span class="chatItem__readStatus" v-show="comment.read">既読</span>
                  <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="comment.json.type === 'CANDIDATE_EXPLANATION'" class="chatItem">
            <div class="chatItem__talk chatItem__talk--self">
              <div class="chatItem__talkMainContainer chatItem__talkMainContainer--self">
                <div class="chatItem__balloon chatItem__balloon--self">
                  <div class="chatItem__text">
                    会場より立候補がありました！<br />
                    ご紹介した会場で<span class="chatItem__kininaruInlineBoxCandidate">チャットする</span>を押すと、会場様と直接連絡でき、条件などのご質問・ご相談ができます。<br />
                    ご予約は会場とのチャットでそのままご依頼いただけます。<br />
                    <br />
                    また、他の会場の紹介も必要でしたら、引き続きコンシェルジュのチャットにてご連絡ください。
                  </div>
                  <div class="chatItem__text--info">
                  予約日時や人数を変更されたい場合は、以下の「予約日時・人数の変更」から変更ください。<br />
                  別なエリア、または複数のエリアでお探しの際はチャットにてお申し付けください。
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="comment.json.type === 'CANDIDATE_AND_SUGGESTION_EXPLANATION'" class="chatItem">
            <div class="chatItem__talk chatItem__talk--self">
              <div class="chatItem__talkMainContainer chatItem__talkMainContainer--self">
                <div class="chatItem__balloon chatItem__balloon--self">
                  <div class="chatItem__text">
                    コンシェルジュがご希望に見合うおすすめの会場をピックアップいたしました！<br />
                    ☆立候補会場空きあり☆と表示されている会場はお客様のご希望とマッチしておりすぐにご案内が可能な会場です！
                    <span class="chatItem__kininaruInlineBoxCandidate">チャットする</span>からやり取りが可能です。<br />
                    <br />
                    また、他のおすすめ会場は<span class="chatItem__kininaruInlineBoxSuggestion">空き確認</span>を押すと、ご希望条件でご利用できるかお調べいたします！<br />
                    ご不明点などございましたらお気軽にコンシェルジュチャットにお申し付け下さいませ。
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="comment.json.type === 'SUGGESTION'" v-for="suggest in comment.json.suggestions" :key="suggest.id" class="chatItem">
            <div class="chatItem__shopPanel">
              <div class="chatItem__shopPanelImage" :style="backgroundImage(suggest.shop.main_image.urls.medium)"></div>
              <div class="chatItem__shopPanelInfo">
                <div class="chatItem__shopPanelTitle">
                  <span>{{ suggest.shop.name }}</span>
                  <a :href="suggest.shop.auth_url" target="_blank"><i class="icon sign in"></i></a>
                </div>
                <ul class="chatItem__shopPanelMeta">
                  <li>
                    <span v-if="suggest.shop.max_count" class="chatItem__shopPanelMetaCapacityMax">TEL：{{ suggest.shop.tel }}</span>
                  </li>
                </ul>
                <div v-if="suggest.status_label" class="chatItem__shopPanelActionContainer">
                  <a v-if="suggest.chat_url" :href="suggest.chat_url" target="_blank" class="ui label">{{ suggest.status_label }}</a>
                  <span v-else class="ui label">{{ suggest.status_label }}</span>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="comment.json.type === 'LIKE'" class="chatItem">
            <div class="chatItem__userActionResult">
              <i class="fas fa-utensils chatItem__userActionResultIcon"></i>「{{ comment.json.shop.name }}」に空き確認を押しました
            </div>
          </div>
          <div v-else-if="comment.json.type === 'LIKE_ACCEPTED'" class="chatItem">
            <div class="chatItem__talk chatItem__talk--self">
              <div class="chatItem__talkMainContainer">
                <div class="chatItem__balloon chatItem__balloon--self">
                  <div class="chatItem__text">
                  「{{ comment.json.shop.name }}」の空きをお調べ致します。<br />
                    空室の有無は各会場の担当者からチャットにてご連絡しますので、直接詳細をご確認ください。<br />
                    ご予約は会場とのチャットでそのままご依頼いただけます。
                  </div>
                </div>
                <div class="chatItem__metaContainer  chatItem__metaContainer--self">
                  <span class="chatItem__readStatus" v-show="comment.read">既読</span>
                  <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="comment.json.type === 'MARUNAGE_UPDATED'" class="chatItem">
            <div class="chatItem__userActionResult">希望条件が更新されました</div>
          </div>

          <div v-else-if="comment.json.type === 'REPLY_RESERVATION_OK' || comment.json.type === 'REPLY_RESERVATION_OK_WITH_CONSULT'" class="chatItem">
            <div class="chatItem__talk chatItem__talk--self">
              <div class="chatItem__talkMainContainer chatItem__talkMainContainer--self">
                <div class="chatItem__balloon chatItem__balloon--self">
                  <div class="chatItem__text">
                    「{{ comment.json.shop.name }}」さんに空きがございました！<br>
                    その後ご連絡は進んでおりますでしょうか？<br>
                    人気日程は埋まりやすいため、早めの【仮予約】や下見がおすすめです。<br><br>
                    他会場のご提案や進め方のご相談も承りますので、お気軽にお知らせください。なお、グルプラ経由でのご成約には最大1万円のAmazonギフト券プレゼントもございます♪
                  </div>
                </div>
                <div class="chatItem__metaContainer chatItem__metaContainer--self">
                  <span class="chatItem__readStatus" v-show="comment.read">既読</span>
                  <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="comment.json.type === 'REPLY_RESERVATION_NG'" class="chatItem">
            <div class="chatItem__talk chatItem__talk--self">
              <div class="chatItem__talkMainContainer chatItem__talkMainContainer--self">
                <div class="chatItem__balloon chatItem__balloon--self">
                  <div class="chatItem__text">
                    お問い合わせの「{{ comment.json.shop.name }}」さんは残念ながら空きがございませんでした。<br>
                    人数規模が大きい場合は複数会場を仮押さえしておくと安心です。<br><br>
                    まだご予約が確定していないようでしたら、条件に合う会場をこちらでピックアップし一括空き照会も可能ですので、お気軽にご相談ください。<br>
                    なお、グルプラ経由でのご成約には最大1万円のAmazonギフト券プレゼントもございます♪
                  </div>
                </div>
                <div class="chatItem__metaContainer chatItem__metaContainer--self">
                  <span class="chatItem__readStatus" v-show="comment.read">既読</span>
                  <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <form class="ui form" @submit.prevent="postChatComment()">
        <div class="field">
          <textarea v-model.trim="commentForm.model.text" rows="3"></textarea>
        </div>
        <button type="submit" class="ui primary tiny button" :class="{'loading': commentForm.waiting}">送信</button>
      </form>
    </div>
    <div class="action-column">
      <div class="ui pointing secondary menu">
        <a class="item active" data-tab="marunage">まるなげ管理</a>
        <a class="item" data-tab="suggest">会場を紹介する</a>
        <a class="item" data-tab="candidates">立候補会場を紹介する<span v-if="marunage">({{ marunage.marunage_candidates.length }})</span></a>
        <a class="item" data-tab="edit">希望条件編集</a>
      </div>

      <div class="ui tab active" data-tab="marunage">
        <form class="ui form" @submit.prevent="saveMarunage()">
          <div class="field">
            <button type="submit" class="ui primary tiny button" :class="{'loading': marunageForm.waiting}">保存する</button>
          </div>
          <div class="fields">
            <div class="field">
              <label>種別</label>
              <dropdown v-model="marunageForm.model.assignee" :options="consts.CONCIERGE_MEMBERS" :placeholder="'種別'"></dropdown>
            </div>
            <div class="field">
              <label>ステータス</label>
              <dropdown v-model="marunageForm.model.status" :options="consts.MARUNAGE_STATUS" :placeholder="'ステータス'"></dropdown>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>担当者メモ <button class="ui mini button" type="button" @click="insertCurrentDateTime('memo')">現在日時を挿入</button></label>
              <textarea v-model="marunageForm.model.memo" rows="8"></textarea>
            </div>
            <div class="field">
              <label>会場への申し送り事項 <button class="ui mini button" type="button" @click="insertCurrentDateTime('message_for_shop')">現在日時を挿入</button></label>
              <textarea v-model="marunageForm.model.message_for_shop" rows="8"></textarea>
            </div>
          </div>
          <div class="field">
            <label>立候補の受け付け</label>
            <div class="fields">
              <div class="field">
                <div class="ui checkbox radio">
                  <input v-model="marunageForm.model.accept_marunage_candidate" type="radio" :value="true" name="accept_marunage_candidate">
                  <label>受け付ける</label>
                </div>
              </div>
              <div class="field">
                <div class="ui checkbox radio">
                  <input v-model="marunageForm.model.accept_marunage_candidate" type="radio" :value="false" name="accept_marunage_candidate">
                  <label>受け付けない</label>
                </div>
              </div>
            </div>
          </div>
          <div class="field">
            <div v-if="marunage">
                [ユーザー側チャット]<br>
                <a :href="marunage.front_marunage_chat_url" target="_blank">{{ origin }}{{ marunage.front_marunage_chat_url }}</a>
            </div>
          </div>
        </form>
        <div class="ui divider"></div>
        <div class="suggested-shops">
          <h3>提案済み会場 <i class="add circle green icon clickable" @click="switchSuggestTab()"></i></h3>
          <div v-if="marunage" class="ui items">
            <div v-for="suggest in marunage.marunage_shops" :key="suggest.id" class="item">
              <a class="ui tiny image">
                <img :src="suggest.shop.main_image.urls.medium_square">
              </a>
              <div class="content">
                <div class="header">
                  <a :href="suggest.shop.edit_url" target="_blank=">{{ suggest.shop.name }}</a>
                  <a :href="suggest.shop.auth_url" target="_blank"><i class="icon sign in"></i></a>
                </div>
                <div class="description">
                  <span v-if="suggest.shop.tel">TEL：{{ suggest.shop.tel }}</span>
                </div>
                <div v-if="suggest.status_label" class="extra">
                  <a v-if="suggest.chat_url" :href="suggest.chat_url" target="_blank" class="ui label">{{ suggest.status_label }}</a>
                  <span v-else class="ui label">{{ suggest.status_label }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ui tab" data-tab="suggest">
        <form class="ui form" @submit.prevent="searchShops()">
          <div class="two fields">
            <div class="field">
              <label>都道府県</label>
              <dropdown v-model="searchForm.model.prefecture" @change="onPrefectureChangeOfSearch()" :placeholder="'指定しない'">
                <option value="">指定しない</option>
                <option v-for="each in consts.SHOP_PREFECTURE" :key="each.label" :value="each.value" :disabled="each.value === ''">{{ each.label }}</option>
              </dropdown>
            </div>
            <div class="field">
              <label>エリア</label>
              <dropdown v-model="searchForm.model.area" @change="onAreaChangeOfSearch()" :placeholder="'指定しない'">
                <option value="">指定しない</option>
                <option v-for="each in this.areaOptionsOfSearch" :key="each.label" :value="each.value" :disabled="each.value === ''">{{ each.label }}</option>
              </dropdown>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>エリア詳細</label>
              <dropdown ref="areaDetailOfSearch" v-model="searchForm.model.area_detail" @change="onAreaDetailChangeOfSearch()" :placeholder="'指定しない'"></dropdown>
            </div>
            <div class="field">
              <label>最寄駅</label>
              <dropdown ref="stationOfSearch" v-model="searchForm.model.stations" :placeholder="'指定しない'" max-size="-1"></dropdown>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>人数下限</label>
              <dropdown v-model="searchForm.model.people_from" :placeholder="'下限なし'">
                  <option value="">下限なし</option>
                  <option v-for="each in consts.MARUNAGE_CHAT_PEOPLE" :key="each.value" :value="each.value">{{ each.label }}</option>
              </dropdown>
            </div>
            <div class="field">
              <label>人数上限</label>
              <dropdown v-model="searchForm.model.people_to" :placeholder="'上限なし'">
                  <option value="">上限なし</option>
                  <option v-for="each in consts.MARUNAGE_CHAT_PEOPLE" :key="each.value" :value="each.value">{{ each.label }}</option>
              </dropdown>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>予算下限</label>
              <dropdown v-model="searchForm.model.price_from" :placeholder="'下限なし'">
                <option value="">下限なし</option>
                <option value="3000">3,000円</option>
                <option value="4000">4,000円</option>
                <option value="5000">5,000円</option>
                <option value="6000">6,000円</option>
                <option value="7000">7,000円</option>
                <option value="8000">8,000円</option>
                <option value="9000">9,000円</option>
                <option value="10000">10,000円</option>
                <option value="13000">13,000円</option>
                <option value="15000">15,000円</option>
                <option value="18000">18,000円</option>
                <option value="20000">20,000円</option>
                <option value="25000">25,000円</option>
                <option value="30000">30,000円</option>
              </dropdown>
            </div>
            <div class="field">
              <label>予算上限</label>
              <dropdown v-model="searchForm.model.price_to" :placeholder="'上限なし'">
                <option value="">上限なし</option>
                <option value="3000">3,000円</option>
                <option value="4000">4,000円</option>
                <option value="5000">5,000円</option>
                <option value="6000">6,000円</option>
                <option value="7000">7,000円</option>
                <option value="8000">8,000円</option>
                <option value="9000">9,000円</option>
                <option value="10000">10,000円</option>
                <option value="13000">13,000円</option>
                <option value="15000">15,000円</option>
                <option value="18000">18,000円</option>
                <option value="20000">20,000円</option>
                <option value="25000">25,000円</option>
                <option value="30000">30,000円</option>
              </dropdown>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>会場の種類(複数選択)</label>
              <dropdown v-model="searchForm.model.shop_types" :options="consts.SHOP_TYPE" :placeholder="'指定しない'" :max-size="-1"></dropdown>
            </div>
            <div class="field">
              <label>喫煙</label>
              <dropdown v-model="searchForm.model.smoking_type" :options="consts.SMOKING" :placeholder="'指定しない'">
                <option value="">指定しない</option>
              </dropdown>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>料理ジャンル(複数選択)</label>
              <dropdown v-model="searchForm.model.genres" :options="consts.SHOP_GENRE" :max-size="-1" :placeholder="'料理ジャンル'"></dropdown>
            </div>
            <div class="field">
              <label>施設・サービス(複数選択)</label>
              <dropdown v-model="searchForm.model.facilities" :options="consts.FACILITY" :max-size="-1" :placeholder="'施設・サービス'"></dropdown>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>ランク</label>
              <checkbox-group v-model="searchForm.model.ranks" :options="consts.SHOP_RANK"></checkbox-group>
            </div>
            <div class="field">
              <label>ステータス</label>
              <checkbox v-model="searchForm.model.is_unpublished_included" ref="subscribed">非公開含む</checkbox>
            </div>
          </div>
          <div class="field">
            <button type="submit" class="ui primary tiny button" :class="{'loading': searchForm.waiting}">検索</button>
          </div>
        </form>
        <div class="ui divider"></div>
        <div class="search-result">
          <div class="search-result-header">
            <div class="total">検索結果{{ pager.total }}件</div>
            <div class="buttons">
              <button type="button" :disabled="suggestions.length === 0" class="ui green tiny button" @click="openSuggestShopsDialog()">提案する ({{ suggestions | length }}件)</button>
              <button type="button" :disabled="suggestions.length === 0" class="ui red tiny button" @click="unselectAll()">すべての選択を解除する</button>
            </div>
          </div>
          <div id="suggest-shops-dialog" class="ui modal">
            <i class="close icon"></i>
            <div class="header">会場を提案する</div>
            <div class="scrolling content">
              <form class="ui form">
                <div class="field">
                  <label>コメント</label>
                  <textarea v-model="suggestForm.model.comment" rows="15"></textarea>
                </div>
              </form>
              <div class="ui items">
                <selectable-shop v-for="shop in suggestions" :shop="shop" :suggestions="suggestions" :marunage="marunage" :key="shop.id"></selectable-shop>
              </div>
            </div>
            <div class="actions">
              <button class="ui cancel button">閉じる</button>
              <button :disabled="suggestions.length === 0" class="ui primary button" :class="{'loading': suggestForm.waiting}" @click="suggest()">送信する</button>
            </div>
          </div>

          <div class="ui items">
            <selectable-shop v-for="shop in shops" :shop="shop" :suggestions="suggestions" :marunage="marunage" :key="shop.id"></selectable-shop>
          </div>
          <div v-show="shops.length > 0 && pager.hasNext()" style="padding-bottom: 200px;">
            <button class="ui fluid button" type="button" @click="searchShops(pager.next())" :class="{'loading': searchForm.waiting}">もっと見る</button>
          </div>
        </div>
      </div>

      <div class="ui tab" data-tab="candidates">
        <div v-if="marunage" class="search-result">
          <div class="search-result-header">
            <div class="total">全{{ marunage.marunage_candidates.length }}件</div>
            <div class="buttons">
              <button type="button" :disabled="suggestions.length === 0" class="ui green tiny button" @click="openSuggestShopsDialog()">提案する ({{ suggestions | length }}件)</button>
              <button type="button" :disabled="suggestions.length === 0" class="ui red tiny button" @click="unselectAll()">すべての選択を解除する</button>
            </div>
          </div>
          <div class="ui items">
            <selectable-shop v-for="candidate in marunage.marunage_candidates" :shop="candidate.shop" :suggestions="suggestions" :marunage="marunage" :candidate="candidate" :key="candidate.id"></selectable-shop>
          </div>
        </div>
      </div>

      <div class="ui tab" data-tab="edit">
        <form class="ui form" @submit.prevent="saveMarunage()">
          <div class="field">
            <button type="submit" class="ui primary tiny button" :class="{'loading': marunageForm.waiting}">保存する</button>
          </div>
          <div class="two fields">
            <div class="field">
              <label>都道府県</label>
              <dropdown v-model="marunageForm.model.prefecture" @change="onPrefectureChange()" :placeholder="'指定しない'">
                <option value="">指定しない</option>
                <option v-for="each in consts.SHOP_PREFECTURE" :key="each.label" :value="each.value" :disabled="each.value === ''">{{ each.label }}</option>
              </dropdown>
            </div>
            <div class="field">
              <label>エリア</label>
              <dropdown v-model="marunageForm.model.area" @change="onAreaChange()" :placeholder="'指定しない'">
                <option value="">指定しない</option>
                <option v-for="each in this.areaOptions" :key="each.label" :value="each.value" :disabled="each.value === ''">{{ each.label }}</option>
              </dropdown>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>エリア詳細</label>
              <dropdown ref="areaDetail" v-model="marunageForm.model.area_detail"></dropdown>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>人数</label>
              <dropdown v-model="marunageForm.model.people" :options="consts.MARUNAGE_PEOPLE"></dropdown>
            </div>
            <div class="field">
              <label>予算</label>
              <dropdown v-model="marunageForm.model.price" :options="consts.MARUNAGE_PRICE"></dropdown>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>希望日</label>
              <datepick v-model="marunageForm.model.event_date" :from="1"></datepick>
            </div>
            <div class="field" >
              <label>希望時間</label>
              <dropdown v-model="marunageForm.model.event_time" :options="consts.MARUNAGE_EVENT_TIME"></dropdown>
            </div>
          </div>
        </form>
      </div>

    </div>
  </div>
</template>

<script>
import SelectableShop from './_selectableShop.vue';

export default {
    components: {
        SelectableShop: SelectableShop,
    },
    props: {
        detailApiUrl: {
            required: true,
            type: String
        }
    },
    data: function() {
        return {
            loadForm: this.createForm(),
            commentForm: this.createForm(),
            $commentsEl: null,
            marunageForm: this.createForm(),
            searchForm: this.createForm({
                area_detail: null
            }),
            suggestForm: this.createForm(),
            marunage: null,
            comments: [],

            currentArea: null,
            pager: this.createPager(10),
            shops: [],
            suggestions: [],
            $modalEl: null,

            areaOptionsOfSearch: [],
            areaOptions: [],
            areas: [],
            areaDetails: [],
            stations: [],
        };
    },
    created: function() {
        this.createForm().get(this.detailApiUrl, function(response) {
            this.marunage = response.data;
            this.marunageForm.model = response.data;
            this.searchForm.model = {
                prefecture: this.marunage.prefecture,
                area: this.marunage.area,
                area_detail: this.marunage.area_detail,
                stations: [],
                people_from: (this.marunage.people || '').split('-')[0],
                price_from: this.marunage.price === 10001 ? 10000 : '',
                price_to: this.marunage.price === 10001 ? '' : this.marunage.price,
                ranks: ['A', 'B'],
                is_unpublished_included: false,
                order_by: 'is_promotion',
            };
            this.createForm().get(this.marunage.marunage_chat.chat_comments_api_url, function(response) {
                this.comments = response.data;
                this.markRead();
                this.$nextTick(function() {
                    this.$commentsEl.animate({scrollTop: 65535}, 100);
                });
                this.setInterval(this.fetchComments, 10 * 1000, false);
            });
            this.createForm().get('/api/areas/', function(response) {
                _.forEach(response.data, function(each) {
                    this.areas.push(each);
                }.bind(this));
                const selectedPrefectureOfSearch = this.searchForm.model.prefecture;
                const selectedPrefecture = this.marunageForm.model.prefecture;
                this.areaOptionsOfSearch = this.areas.filter(area => area.prefecture === selectedPrefectureOfSearch);
                this.areaOptions = this.areas.filter(area => area.prefecture === selectedPrefecture);
            });
            this.createForm().get('/api/area_details/', function(response) {
                _.forEach(response.data, function(each) {
                    this.areaDetails.push(each);
                }.bind(this));
                this.onAreaChangeOfSearch(true);
                this.onAreaChange(true);
            });
            this.createForm().get('/api/stations/', function(response) {
                _.forEach(response.data, function(each) {
                    this.stations.push(each);
                }.bind(this));
                this.onAreaDetailChangeOfSearch(true);
            });
        });
    },
    mounted: function() {
        $('.menu .item').tab();
        this.$modalEl = $('#suggest-shops-dialog');
        this.$commentsEl = $('.chatItemContainer');
    },
    watch: {
        comments: function() {
            _.forEach(this.comments, function(comment) {
                if (_.isString(comment.json)) {
                    comment.json = JSON.parse(comment.json);
                    if (comment.json.type === 'SUGGESTION') {
                        comment.json.suggestions = _.map(comment.json.suggestions, function(suggestedShopId) {
                            return _.find(this.marunage.marunage_shops, function(each) {
                                return each.shop.id === suggestedShopId;
                            });
                        }.bind(this));
                    }
                    if (_.includes(['LIKE', 'LIKE_ACCEPTED', 'REPLY_RESERVATION_OK', 'REPLY_RESERVATION_OK_WITH_CONSULT', 'REPLY_RESERVATION_NG'], comment.json.type)) {
                        var marunageShop = _.find(this.marunage.marunage_shops, function(each) {
                            return each.shop.id === comment.json.shop_id;
                        });
                        if (marunageShop) {
                            comment.json.shop = marunageShop.shop;
                        }
                    }
                    if (comment.json.type === 'REDIRECT_TO_V1') {
                        window.location.href = 'https://v1.gourmetplus.jp/admin/chat/' + comment.json.original_chat_id;
                    }
                }
            }.bind(this));
        }
    },
    methods: {
        insertCurrentDateTime: function(fieldName) {
            if (!this.marunageForm.model[fieldName]) {
                this.marunageForm.model[fieldName] = '';
            }
            this.marunageForm.model[fieldName] += ' ' + moment().format('YYYY/MM/DD(ddd) HH:mm');
        },
        markRead: function() {
            this.createForm().put(this.marunage.marunage_chat.chat_comments_read_api_url).then(function() {
                this.fetchUnreadNotifications();
            }.bind(this));
        },
        fetchComments: function() {
            this.loadForm.get(this.marunage.marunage_chat.chat_comments_api_url, function(response) {
                var isUpdated = this.comments.length !== response.data.length;
                this.comments = response.data;
                if (isUpdated) {
                    this.createForm().get(this.detailApiUrl, function(response) {
                        this.marunage = response.data;
                        this.marunageForm.model = response.data;
                    });
                    this.$nextTick(function() {
                        this.$commentsEl.animate({scrollTop: 65535}, 1000);
                    });
                    this.markRead();
                }
            });
        },
        switchSuggestTab: function() {
            $('.ui.menu [data-tab=suggest]').click();
        },
        postChatComment: function() {
            if (!this.commentForm.model.text) {
                return;
            }
            this.commentForm.post(this.marunage.marunage_chat.chat_comments_api_url, function(response) {
                this.comments.push(response.data);
                this.commentForm.model.text = '';
                this.$nextTick(function() {
                    this.$commentsEl.animate({scrollTop: 65535}, 1000);
                });
                this.fetchComments();
            });
        },
        saveMarunage: function() {
            if (this.marunageForm.waiting) {
                return;
            }
            var payload = _.pick(this.marunageForm.model, [
                'assignee',
                'status',
                'memo',
                'message_for_shop',
                'accept_marunage_candidate',
                'area',
                'area_detail',
                'people',
                'price',
                'event_date',
                'event_time',
                'email',
                'tel',
            ]);
            this.marunageForm.clear();
            this.marunageForm.waiting = true;
            this.$http.put(this.detailApiUrl, payload).then(function() {
                this.marunageForm.waiting = false;
                alert('保存しました');
            }.bind(this), function(err) {
                this.marunageForm.waiting = false;
                this.marunageForm._handleError(err);
            }.bind(this));
        },
        onPrefectureChange: function() {
            const selectedPrefecture = this.marunageForm.model.prefecture;
            if (selectedPrefecture === '') {
                this.marunageForm.model.area = null;
                this.areaOptions = [];
            } else {
                this.areaOptions = this.areas.filter(area => area.prefecture === selectedPrefecture);
                if (this.areaOptions.length > 0) {
                    this.marunageForm.model.area = null;
                }
            }
        },
        onAreaChange: function(keepAreaDetail) {
            if (!keepAreaDetail) {
                this.marunageForm.model.area_detail = null;
            }
            this.$refs.areaDetail.setOptions(this.areaDetailsOf(this.marunageForm.model.area, this.areaDetails));
        },
        onPrefectureChangeOfSearch: function() {
            const selectedPrefecture = this.searchForm.model.prefecture;
            if (selectedPrefecture === '') {
                this.searchForm.model.area = null;
                this.areaOptionsOfSearch = [];
            } else {
                this.areaOptionsOfSearch = this.areas.filter(area => area.prefecture === selectedPrefecture);
                if (this.areaOptionsOfSearch.length > 0) {
                    this.searchForm.model.area = null
                }
            }
        },
        onAreaChangeOfSearch: function(keepAreaDetail) {
            if (!keepAreaDetail) {
                this.searchForm.model.area_detail = null;
            }
            this.$refs.areaDetailOfSearch.setOptions(this.areaDetailsOf(this.searchForm.model.area, this.areaDetails));
        },
        onAreaDetailChangeOfSearch: function(keepStation) {
            if (!keepStation) {
                this.searchForm.model.stations = [];
            }
            this.$refs.stationOfSearch.setOptions(this.stationsOfAreaDetail(this.searchForm.model.area_detail, this.stations));
        },
        searchShops: function(opt_position) {
            var position = opt_position || this.pager.first();
            this.merge(this.searchForm.model, position);
            if (position.offset === 0) {
                this.clearArray(this.shops);
            }
            this.searchForm.model.is_public = this.searchForm.model.is_unpublished_included ? null : true;
            this.searchForm.get('/afadmin/api/shops', function(response) {
                _.forEach(response.data, function(each) {
                    this.shops.push(each);
                }.bind(this));
                this.pager.update(response.data, response);
            });
        },
        unselectAll: function() {
            this.clearArray(this.suggestions);
        },
        openSuggestShopsDialog: function() {
            this.suggestForm.model = {
                comment:  [
'グルプラのまるなげくんです♪',
'お問い合わせありがとうございます！',
'',
'素敵な宴席になるようサポートさせて頂きます＾＾',
'',
'下記の会場はいかがでしょうか？',
'',
'また、こちらのサイトからご予約いただけますと、＜Amazon ギフト券＞をお届けできます♪'
                ].join('\n')
            };
            this.$modalEl.modal('show');
        },
        suggest: function() {
            this.suggestForm.model.suggestions = _.map(this.suggestions, function(each) {
                return each.id;
            })
            this.suggestForm.post(this.marunage.suggest_api_url, function(response) {
                this.marunage.marunage_shops = response.data;
                this.suggestForm.model.comment = null;
                this.fetchComments();
                this.unselectAll();
                this.$modalEl.modal('hide');
            });
        },
    },
    computed: {
        loading: function() {
            return _.isEmpty(this.marunageForm.model) || _.isEmpty(this.comments);
        }
    }
};
</script>
